import React, { FunctionComponent, useEffect, useState } from 'react';
import { useTheme } from '@mui/material/styles';
import { useAtom } from 'jotai';
// import { useNavigate } from 'react-router-dom';
import { useMutation, useQuery } from '@tanstack/react-query';

import { Tooltip, PieChart, Pie, Cell } from 'recharts';

import { fetchAll, fetchOne } from '../../lib/v31lib';
import { loginAtom } from '../../lib/auth';

import PercentIcon from '@mui/icons-material/Percent';
import PieChartIcon from '@mui/icons-material/PieChart';
import TrendingDownIcon from '@mui/icons-material/TrendingDown';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import VisibilityIcon from '@mui/icons-material/Visibility';

import {
  Box,
  Button as Btn,
  DialogActions,
  Divider,
  Grid,
  Tooltip as Tooltt,
} from '@mui/material';

import {
  AnnAm,
  Page,
  StyledButton,
  StyledSelect,
  Typography,
} from '../../components/interface';

import {
  Investment
} from '../../models';
import { Base } from '../../components/dialogs/Base';

// const { DateTime } = require("luxon");

type Props = {};

export const InvestmentsStats: FunctionComponent<Props> = () => {
  // const navigate = useNavigate();
  const theme = useTheme();
  
  const [login, setLogin] = useAtom(loginAtom);
  const [data, setData] = useState<any>();
  const [investmentId, setInvestmentId] = useState<string>('0');
  const [tableToggle, setTableToggle] = useState<boolean>(false);
  const [showPop, setShowPop] = useState<any>();
  const RATING_COLOURS_MAIN = {
    "A": "#42f557",
    "B": "#cad419",
    "C": "#c74d28",
    "S": "#ba0d35"
  }
  const RATING_COLOURS_SUB = {
    "AAA": "#42f557",
    "AA": "#2ec941",
    "A": "#229c31",
    "BBB": "#cad419",
    "BB": "#a1a814",
    "B": "#73780e",
    "CCC": "#c74d28",
    "SD/D": "#ba0d35"
  }
  const RATING_COLOURS_ALL = {
    "AAA": "#42f557",
    "AA+": "#2ec941",
    "AA": "#28b538",
    "AA−": "#219e2f",
    "A+": "#229c31",
    "A": "#1d852a",
    "A−": "#167022",
    "BBB+": "#cad419",
    "BBB": "#b9c215",
    "BBB−": "#aab314",
    "BB+": "#a1a814",
    "BB": "#8e9412",
    "BB−": "#7d8210",
    "B+": "#73780e",
    "B": "#62660c",
    "B−": "#515409",
    "CCC+": "#c74d28",
    "CCC": "#b54624",
    "CCC−": "#9c3b1e",
    "SD/D": "#ba0d35"
  }
  // "AAA", '', '', '', 
  // "AA+", "AA", "AA−", '',
  // "A+", "A", "A−", '',
  // "BBB+", "BBB", "BBB−", '',
  // "BB+", "BB", "BB−", '',
  // "B+", "B", "B−", '',
  // "CCC+", "CCC", "CCC−", '',
  // "SD/D", '', '', ''
  const investmentTypes:{[z:string]: string} = {
    'bonds': "Bonds",
    'real_estate': "Real Estate",
    // 'obligations': "Obligations",
    'equities': "Equities",
    'gold': "Gold & other commodities"
  };

  const {
    data: investments,
    // isLoading: bookYearsLoading,
    // isError: bookYearsError,
    // isSuccess: bookYearsSuccess,
    refetch: investmentsRefetch,
  } = useQuery({
    queryKey: ["investments_short"],
    queryFn: () =>
      fetchAll<Investment>(
        "/nl/v3/objects/fetch_all",
        {
          object: "investment",
          fields: [
            "id", 'name', 'isin'
          ],
          order: "name ASC",
          page: 0,
          per_page: 200
        },
        login
      ),
    enabled: !!login
  });









  const mutationCustomAction = useMutation({
    mutationFn: (pars: {
      formData: any;
    }) => {
      return fetchOne<any>(
        "/nl/v3/objects/custom_action",
        pars.formData,
        login
      );
    },
    onSuccess: (data, variables, context) => {
      setData(data.custom_result);
    },
  });








  // useEffect(() => {
  //   mutationCustomAction.mutate({
  //     formData: {
  //       object: 'investment',
  //       class_action: 'current_stats'
  //     }
  //   });
  // }, []);
  useEffect(() => {
    mutationCustomAction.mutate({
      formData: {
        object: 'investment',
        class_action: 'current_stats',
        investment_id: investmentId
      }
    });
  }, [investmentId]);
  






  const renderLabel = (entry:any) => {
    return entry.name;
  }

  return <Page sx={{}} title="Investment Statistics" helper="investment_stats">
    <Grid container spacing={1}>
      <Grid item xs={8}>
        <StyledSelect
          label="Investment"
          value={investmentId?.toString() || '0'}
          id="investment_id"
          onChange={(v) => {
            setInvestmentId(!!v ? v : '0');
          }}
          list={[
            {id: '0', name: "--- All ---"},
            ...Object.keys(investmentTypes).sort().map(kkk => {
              return {id: kkk, name: `-- ${investmentTypes[kkk]} --`};
            }),
            ...(investments || []).map(mngr => {
              return {id: mngr.id?.toString() || '', name: mngr.name || ''};
            })
          ]}
        />
      </Grid>
      <Grid item xs={4}>
        <StyledButton
          label="Toggle"
          startIcon={<PieChartIcon />}
          endIcon={<PercentIcon />}
          id='import'
          onClick={(v) => {
            setTableToggle(!tableToggle);
          }}
          sx={{marginTop: 1}}
        />
      </Grid>
      {!tableToggle && <Grid item xs={6}>
        {!!data?.original && <PieChart width={400} height={400}>
          <Pie
            dataKey="value"
            isAnimationActive={false}
            data={Object.keys(data.original).map(kk => {return {name: kk, value: parseFloat(data.current[kk])};})}
            cx="50%"
            cy="50%"
            outerRadius={80}
            fill="#8884d8"
            label={renderLabel}
          />
          {/* <Tooltip /> */}
        </PieChart>}
      </Grid>}
      {!!tableToggle && <Grid item xs={6}>
        {/* table */}
        <Grid container spacing={1}>
          <Grid item xs={6}><Typography variant="subtitle1" sx={{fontWeight: 'bold', textDecoration: 'underline'}}>Name</Typography></Grid>
          <Grid item xs={6} sx={{textAlign: 'center'}}><Typography variant="subtitle1" sx={{fontWeight: 'bold', textDecoration: 'underline'}}>Value</Typography></Grid>
          {Object.keys(data.original).map(kk => <>
            <Grid item xs={6}><Typography>{kk}</Typography></Grid>
            <Grid item xs={4} sx={{textAlign: 'right'}}><AnnAm amount={parseFloat(data.current[kk] || 0)} currency={kk} /></Grid>
            <Grid item xs={2} sx={{textAlign: 'right'}}><Typography>{((parseFloat(data.current[kk] || 0) / parseFloat(data.original[kk] || 0) * 100) - 100) >= 0 && "+"}{((parseFloat(data.current[kk] || 0) / parseFloat(data.original[kk] || 0) * 100) - 100).toFixed(2)}%</Typography></Grid>
          </>)}
        </Grid>
      </Grid>}
      <Grid item xs={6} container spacing={1} sx={{alignContent: 'baseline'}}>
        {!!data?.original && Object.keys(data.original).map(kk => <Grid item xs={12}>
          <Box sx={{
            border: '1px solid transparent',
            borderColor: (parseFloat(data.current[kk] || 0) > parseFloat(data.original[kk] || 0) ? theme.palette.primary.main : theme.palette.secondary.main),
            backgroundColor: (parseFloat(data.current[kk] || 0) > parseFloat(data.original[kk] || 0) ? theme.palette.opacitated?.main_01 : theme.palette.opacitated?.secondary_02),
            borderRadius: 1,
            padding: 2,
            textAlign: 'center',
            "& > p": {
              textAlign: 'center',
              fontSize: '1.2rem'
            }
          }}>
            <AnnAm amount={parseFloat(data.current[kk] || 0)} currency={kk} />
            <Divider />
            <Typography sx={{
              fontSize: '0.9rem',
              textAlign: 'right !important',
              "& > p": {
                display: 'inline-block'
              }
            }}>
              {parseFloat(data.current[kk] || 0) > parseFloat(data.original[kk] || 0) && <TrendingUpIcon sx={{
                color: theme.palette.tertiary?.main,
                marginRight: 1,
                marginBottom: -1
              }} />}
              {parseFloat(data.current[kk] || 0) <= parseFloat(data.original[kk] || 0) && <TrendingDownIcon sx={{
                color: theme.palette.secondary?.main,
                marginRight: 1,
                marginBottom: -1
              }} />}
              <AnnAm amount={parseFloat(data.original[kk] || 0)} currency={kk} />
            </Typography>
          </Box>
        </Grid>)}
      </Grid>
      <Grid item xs={12}>
        <Divider />
      </Grid>
      {!tableToggle && <Grid item xs={6}>
        <Typography variant="h3">Sector breakdown</Typography>
        {!!data?.sector_breakdown && <PieChart width={400} height={400}>
          <Pie
            dataKey="value"
            isAnimationActive={false}
            data={Object.keys(data.sector_breakdown).sort((a, b) => parseFloat(data.sector_breakdown[a].percentage || 0) < parseFloat(data.sector_breakdown[b].percentage || 0) ? 1 : -1).filter(fff => fff !== '_total').map(kk => {return {name: data.sector_breakdown[kk].name, value: parseFloat(data.sector_breakdown[kk].percentage)};})}
            cx="50%"
            cy="50%"
            outerRadius={80}
            fill="#8884d8"
            label={renderLabel}
          />
          <Tooltip />
        </PieChart>}
      </Grid>}
      {!!tableToggle && <Grid item xs={6}>
        {/* table */}
        <Grid container spacing={1}>
        <Grid item xs={12}><Typography variant="h3">Sector breakdown</Typography></Grid>
          <Grid item xs={6}><Typography variant="subtitle1" sx={{fontWeight: 'bold', textDecoration: 'underline'}}>Name</Typography></Grid>
          <Grid item xs={6} sx={{textAlign: 'center'}}><Typography variant="subtitle1" sx={{fontWeight: 'bold', textDecoration: 'underline'}}>Value</Typography></Grid>
          {Object.keys(data.sector_breakdown).sort((a, b) => parseFloat(data.sector_breakdown[a].percentage || 0) < parseFloat(data.sector_breakdown[b].percentage || 0) ? 1 : -1).filter(fff => fff !== '_total').map(kk => <>
            <Grid item xs={6}><Typography>{data.sector_breakdown[kk].name}</Typography></Grid>
            <Grid item xs={4} sx={{textAlign: 'right'}}>
              <VisibilityIcon color="primary" sx={{cursor: 'pointer'}} onClick={() => {
                setShowPop(<Box>
                  {data.sector_breakdown[kk].investments.map((inv:any) => <Typography>{inv.name} (<AnnAm amount={parseFloat(inv.value || 0)} currency={inv.currency} sx={{display: 'inline'}} />)</Typography>)}
                </Box>);
              }} />
            </Grid>
            <Grid item xs={2} sx={{textAlign: 'right'}}><Typography>{(parseFloat(data.sector_breakdown[kk].percentage || 0)).toFixed(2)}%</Typography></Grid>
          </>)}
        </Grid>
      </Grid>}
      {!tableToggle && <Grid item xs={6}>
        <Typography variant="h3">Company breakdown</Typography>
        {!!data?.company_breakdown && <PieChart width={400} height={400}>
          <Pie
            dataKey="value"
            isAnimationActive={false}
            data={Object.keys(data.company_breakdown).sort((a, b) => parseFloat(data.company_breakdown[a].percentage || 0) < parseFloat(data.company_breakdown[b].percentage || 0) ? 1 : -1).filter(fff => fff !== '_total').map(kk => {return {name: data.company_breakdown[kk].name, value: parseFloat(data.company_breakdown[kk].percentage)};})}
            cx="50%"
            cy="50%"
            outerRadius={80}
            fill="#8884d8"
            label={renderLabel}
          />
          <Tooltip />
        </PieChart>}
      </Grid>}
      {!!tableToggle && <Grid item xs={6}>
        {/* table */}
        <Grid container spacing={1}>
        <Grid item xs={12}><Typography variant="h3">Company breakdown</Typography></Grid>
          <Grid item xs={6}><Typography variant="subtitle1" sx={{fontWeight: 'bold', textDecoration: 'underline'}}>Name</Typography></Grid>
          <Grid item xs={6} sx={{textAlign: 'center'}}><Typography variant="subtitle1" sx={{fontWeight: 'bold', textDecoration: 'underline'}}>Value</Typography></Grid>
          {Object.keys(data.company_breakdown).sort((a, b) => parseFloat(data.company_breakdown[a].percentage || 0) < parseFloat(data.company_breakdown[b].percentage || 0) ? 1 : -1).filter(fff => fff !== '_total').map(kk => <>
            <Grid item xs={6}><Typography>{data.company_breakdown[kk].name}</Typography></Grid>
            <Grid item xs={4} sx={{textAlign: 'right'}}>
              <VisibilityIcon color="primary" sx={{cursor: 'pointer'}} onClick={() => {
                setShowPop(<Box>
                  {data.company_breakdown[kk].investments.map((inv:any) => <Typography>{inv.name} (<AnnAm amount={parseFloat(inv.value || 0)} currency={inv.currency} sx={{display: 'inline'}} />)</Typography>)}
                </Box>);
              }} />
            </Grid>
            <Grid item xs={2} sx={{textAlign: 'right'}}><Typography>{(parseFloat(data.company_breakdown[kk].percentage || 0)).toFixed(2)}%</Typography></Grid>
          </>)}
        </Grid>
      </Grid>}
      {!tableToggle && <Grid item xs={6}>
        <Typography variant="h3">Rating breakdown</Typography>
        {!!data?.rating_breakdown && <PieChart width={400} height={400}>
          <Pie
            dataKey="value"
            isAnimationActive={false}
            data={[
              "A", 
              "B", 
              "C", 
              "S"
            ].filter(fff => !!data.rating_breakdown_main[fff]).map(kk => {return {name: data.rating_breakdown_main[kk].name, value: parseFloat(data.rating_breakdown_main[kk].percentage)};})}
            cx="50%"
            cy="50%"
            outerRadius={60}
            fill="#8884d8"
          >
            {[
              "A", 
              "B", 
              "C", 
              "S"
            ].filter(fff => !!data.rating_breakdown_main[fff]).map(kk => {return {name: data.rating_breakdown_main[kk].name, value: parseFloat(data.rating_breakdown_main[kk].percentage)};}).map((entry, index) => (
              <Cell
                key={`cell-${entry.name}`}
                // @ts-ignore
                fill={RATING_COLOURS_MAIN[entry.name]}
              />
            ))}
          </Pie>
          <Pie
            dataKey="value"
            isAnimationActive={false}
            data={[
              "AAA", 
              "AA", 
              "A", 
              "BBB", 
              "BB", 
              "B", 
              "CCC", 
              "SD/D"
            ].filter(fff => !!data.rating_breakdown_sub[fff]).map(kk => {return {name: data.rating_breakdown_sub[kk].name, value: parseFloat(data.rating_breakdown_sub[kk].percentage)};})}
            cx="50%"
            cy="50%"
            innerRadius={70}
            outerRadius={90}
            fill="#8884d8"
          >
            {[
              "AAA", 
              "AA", 
              "A", 
              "BBB", 
              "BB", 
              "B", 
              "CCC", 
              "SD/D"
            ].filter(fff => !!data.rating_breakdown_sub[fff]).map(kk => {return {name: data.rating_breakdown_sub[kk].name, value: parseFloat(data.rating_breakdown_sub[kk].percentage)};}).map((entry, index) => (
              <Cell
                key={`cell-${entry.name}`}
                // @ts-ignore
                fill={RATING_COLOURS_SUB[entry.name]}
              />
            ))}
          </Pie>
          <Pie
            dataKey="value"
            isAnimationActive={false}
            data={[
              "AAA", 
              "AA+", "AA", "AA−", 
              "A+", "A", "A−", 
              "BBB+", "BBB", "BBB−", 
              "BB+", "BB", "BB−", 
              "B+", "B", "B−", 
              "CCC+", "CCC", "CCC−", 
              "SD/D"
            ].filter(fff => !!data.rating_breakdown[fff]).map(kk => {return {name: data.rating_breakdown[kk].name, value: parseFloat(data.rating_breakdown[kk].percentage)};})}
            cx="50%"
            cy="50%"
            innerRadius={100}
            outerRadius={120}
            fill="#8884d8"
            label={renderLabel}
          >
            {[
              "AAA", 
              "AA+", "AA", "AA−", 
              "A+", "A", "A−", 
              "BBB+", "BBB", "BBB−", 
              "BB+", "BB", "BB−", 
              "B+", "B", "B−", 
              "CCC+", "CCC", "CCC−", 
              "SD/D"
            ].filter(fff => !!data.rating_breakdown[fff]).map(kk => {return {name: data.rating_breakdown[kk].name, value: parseFloat(data.rating_breakdown[kk].percentage)};}).map((entry, index) => (
              <Cell
                key={`cell-${entry.name}`}
                // @ts-ignore
                fill={RATING_COLOURS_ALL[entry.name]}
              />
            ))}
          </Pie>
          <Tooltip />
        </PieChart>}
      </Grid>}
      {!!tableToggle && <Grid item xs={6}>
        {/* table */}
        <Grid container spacing={1}>
        <Grid item xs={12}><Typography variant="h3">Rating breakdown</Typography></Grid>
          <Grid item xs={6}><Typography variant="subtitle1" sx={{fontWeight: 'bold', textDecoration: 'underline'}}>Name</Typography></Grid>
          <Grid item xs={6} sx={{textAlign: 'center'}}><Typography variant="subtitle1" sx={{fontWeight: 'bold', textDecoration: 'underline'}}>Value</Typography></Grid>
            {[
              "AAA", 'div',
              "AA+", "AA", "AA−", 'div',
              "A+", "A", "A−", 'div',
              "BBB+", "BBB", "BBB−", 'div',
              "BB+", "BB", "BB−", 'div',
              "B+", "B", "B−", 'div',
              "CCC+", "CCC", "CCC−", 'div',
              "SD/D", 'div'
            ].filter(fff => fff === 'div' || !!data.rating_breakdown[fff]).map((kk, ii) => <>
            {kk === 'div' && [
              "AAA", 'div',
              "AA+", "AA", "AA−", 'div',
              "A+", "A", "A−", 'div',
              "BBB+", "BBB", "BBB−", 'div',
              "BB+", "BB", "BB−", 'div',
              "B+", "B", "B−", 'div',
              "CCC+", "CCC", "CCC−", 'div',
              "SD/D", 'div'
            ].filter(fff => fff === 'div' || !!data.rating_breakdown[fff])[ii-1] !== 'div' && <Grid item xs={12}><Divider /></Grid>}
            {kk !== 'div' && <>
              <Grid item xs={6}><Typography>{kk}</Typography></Grid>
              <Grid item xs={4} sx={{textAlign: 'right'}}>
                <VisibilityIcon color="primary" sx={{cursor: 'pointer'}} onClick={() => {
                  setShowPop(<Box>
                    {data.rating_breakdown[kk].investments.map((inv:any) => <Typography>{inv.name} (<AnnAm amount={parseFloat(inv.value || 0)} currency={inv.currency} sx={{display: 'inline'}} />)</Typography>)}
                  </Box>);
                }} />
              </Grid>
              <Grid item xs={2} sx={{textAlign: 'right'}}><Typography>{(parseFloat(data.rating_breakdown[kk].percentage || 0)).toFixed(2)}%</Typography></Grid>
            </>}
          </>)}
        </Grid>
      </Grid>}
    </Grid>

    <Base
      name="showPop"
      hidden={!showPop}
      maxWidth="xl"
      content={<Grid container spacing={1}>
        <Grid item xs={12}>
          {showPop}
        </Grid>
      </Grid>}
      actions={<DialogActions>
        <Btn autoFocus onClick={() => {setShowPop(undefined);}}>Close</Btn>
      </DialogActions>}
      open={!!setShowPop}
      setOpen={() => {setShowPop(undefined);}}
    />
  </Page>;
}
